// extracted by mini-css-extract-plugin
module.exports = {"story_newworld":"StoryNewWorld_story_newworld__DniR2","story_mobile_ewworld":"StoryNewWorld_story_mobile_ewworld__gMRP_"};